import { useState } from 'react';

import PanoramaViewer, { type PanoramaFrame } from '../components/PanoramaViewer';
import { pt } from '../copy';

const fixtureFrames: readonly [PanoramaFrame, PanoramaFrame] = [
  { id: 'a', src: '/fixtures/pano-a.png', year: 1900 },
  { id: 'b', src: '/fixtures/pano-b.png', year: 2100 },
];

function lerpYear(t: number) {
  const [firstFrame, lastFrame] = fixtureFrames;
  return Math.round(firstFrame.year + (lastFrame.year - firstFrame.year) * t);
}

export default function ViewerTest() {
  const [t, setT] = useState(0);

  return (
    <main className="relative min-h-screen overflow-hidden bg-slate-950 text-slate-100">
      <PanoramaViewer
        className="absolute inset-0"
        frames={fixtureFrames}
        blendT={t}
        hint={pt.viewerHint}
      />

      <div className="pointer-events-none absolute inset-x-0 bottom-0 p-4 sm:p-6">
        <div className="pointer-events-auto mx-auto w-full max-w-3xl rounded-2xl border border-white/10 bg-slate-950/72 p-4 shadow-2xl shadow-black/30 backdrop-blur-md">
          <div className="mb-3 flex items-center justify-between gap-4 text-sm text-slate-200">
            <span className="font-medium tracking-wide text-slate-100">{pt.timeSliderLabel}</span>
            <span className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs uppercase tracking-[0.24em] text-slate-300">
              {lerpYear(t)}
            </span>
          </div>

          <input
            aria-label={pt.timeSliderLabel}
            className="h-2 w-full cursor-pointer accent-cyan-400"
            max={1}
            min={0}
            step={0.01}
            type="range"
            value={t}
            onChange={(event) => setT(Number(event.target.value))}
          />

          <p className="mt-3 text-xs text-slate-400">{pt.viewerHint}</p>
        </div>
      </div>
    </main>
  );
}
